/**
 * Appends an array or comma-separated string to query parameters.
 * @param queryParams - The URLSearchParams object to append to.
 * @param key - The key for the query parameter.
 * @param value - The value to append, which can be an array or a comma-separated string.
 */
export const buildQueryParamForArray = (queryParams: URLSearchParams, key: string, value: string | string[]) => {
  if (Array.isArray(value)) {
    value.forEach((item) => {
      queryParams.append(key, item);
    });
  } else {
    const valueArray = value.split(',');
    valueArray.forEach((item) => {
      queryParams.append(key, item);
    });
  }
};
